//Using slick slider https://kenwheeler.github.io/slick/

(function($){
    $(document).ready(function(){
        $('.zn-quote-slider-stage').slick({
            accessibility: true,
            infinite: true,
            prevArrow: $('.zn-quote-slider-btn.zn-prev'),
            nextArrow: $('.zn-quote-slider-btn.zn-next')
        });
    });
})($JQ);